import React from "react";
import cv from "./files/cv.pdf";

const links = [
  {
    label: "GitHub",
    value: "@EH127 ↗",
    href: "https://github.com/EH127",
    external: true,
  },
  {
    label: "LinkedIn",
    value: "eladhodeda ↗",
    href: "https://www.linkedin.com/in/eladhodeda",
    external: true,
  },
  {
    label: "WhatsApp",
    value: "+972 52 620 3445 ↗",
    href: "https://wa.me/972526203445",
    external: true,
  },
  {
    label: "CV",
    value: "PDF ↓",
    href: cv,
    download: "elad-hodeda-cv.pdf",
  },
];

const Contact = () => (
  <section id="contact" className="section">
    <div className="section-head">
      <span className="section-num">05</span>
      <h2>Contact</h2>
    </div>
    <p className="contact-lede">
      Looking for a developer who's as comfortable with a soldering iron as
      with a terminal? Let's talk.
    </p>
    <a className="contact-email" href="mailto:elad.hodeda3@gmail.com">
      elad.hodeda3@gmail.com
    </a>
    <div className="contact-links">
      {links.map((link) => (
        <a
          key={link.label}
          className="contact-link"
          href={link.href}
          download={link.download}
          {...(link.external ? { target: "_blank", rel: "noreferrer" } : {})}
        >
          <span className="label">{link.label}</span>
          <span className="value">{link.value}</span>
        </a>
      ))}
    </div>
  </section>
);

export default Contact;
